document.addEventListener('click', (event) => {
  const question = event.target.closest('.template-product .home-faq .faq-question');

  if (!question) return;

  const faq = question.closest('.home-faq');
  const currentItem = question.closest('.faq-box');

  faq.querySelectorAll('.faq-box.active').forEach((item) => {
    if (item !== currentItem) {
      item.classList.remove('active');
    }
  });
});
